















import { Component, Vue } from 'vue-property-decorator'

// import firebase from 'firebase/app'
// import 'firebase/auth'

@Component
export default class Page404 extends Vue {}
